// Copyright (c) StrangeBee 2024

import React, { ReactElement, ReactNode } from 'react';
import { HeaderActionType } from '@Types';
import HeaderButton from '@Atoms/Buttons/HeaderButton/HeaderButton';

import './THHeader.scss';

interface THHeaderProps {
    actions?: HeaderActionType[];
    title: ReactNode;
}

export const THHeader = ({ title, actions }: THHeaderProps): ReactElement => {
    return (
        <div className="th-header header-content">
            <div className="th-header__title">{title}</div>
            {actions && (
                <div className="th-header__actions">
                    {actions.map(
                        ({
                            label,
                            icon,
                            Action,
                            disabled = false,
                            hidden = false,
                            className = '',
                        }): ReactElement | null => {
                            if (hidden) {
                                return null;
                            }

                            const button = (
                                <HeaderButton disabled={disabled} label={label} icon={icon} className={className} />
                            );

                            const ButtonElement = !disabled && Action ? (Action(button) as ReactElement) : button;

                            return React.cloneElement(ButtonElement, { key: `buttonHeader${label}` });
                        },
                    )}
                </div>
            )}
        </div>
    );
};
